<template>
  <div>
    <b-card title="Contact us about StructuredEdge" />

    <!--<b-card title="Reset your password">
      <div class="d-flex w-100 justify-content-center">
        <div style="max-width: 1000px">
          <validation-observer ref="resetPasswordRules">
            <b-form @submit.prevent="submitResetPassword">
              <b-row>
                <b-col md="5">
                  <b-form-group
                    label="Username"
                    label-for="username"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Username"
                      rules=""
                    >
                      <b-form-input
                        id="username"
                        v-model="resetPassword.username"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="2"
                  class="d-flex align-items-center justify-content-center"
                >
                  <span>or</span>
                </b-col>
                <b-col md="5">
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="email"
                    >
                      <b-form-input
                        id="email"
                        v-model="resetPassword.email"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="resetPassword.loading"
                  >
                    <b-spinner
                      v-if="resetPassword.loading"
                      small
                    />
                    <span v-else>Submit</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </div>
    </b-card> -->

    <b-card title="Please send us your enquiry and feedback">
      <div class="d-flex w-100 justify-content-center">
        <div style="max-width: 1000px">
          <validation-observer ref="contactUsRules">
            <b-form @submit.prevent="submit">
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Name"
                    label-for="name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Name"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="contactUs.name"
                        :readonly="isLoggedIn && !!userContactDetails.name"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Company"
                    label-for="company"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Company"
                      rules="required"
                    >
                      <b-form-input
                        id="company"
                        v-model="contactUs.company"
                        :readonly="isLoggedIn && !!userContactDetails.company"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="required|email"
                    >
                      <b-form-input
                        id="email"
                        v-model="contactUs.email"
                        :readonly="isLoggedIn && !!userContactDetails.email"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Telephone"
                    label-for="telephone"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Telephone"
                      rules="required"
                    >
                      <b-form-input
                        id="telephone"
                        v-model="contactUs.telephone"
                        :readonly="isLoggedIn && !!userContactDetails.telephone"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Subject"
                    label-for="subject"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Subject"
                      rules="required"
                    >
                      <b-form-input
                        id="subject"
                        v-model="contactUs.subject"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Message"
                    label-for="message"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Message"
                      rules="required"
                    >
                      <b-form-textarea
                        id="message"
                        v-model="contactUs.message"
                        :state="errors.length > 0 ? false:null"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-button
                    type="submit"
                    variant="primary"
                    :disabled="contactUs.loading"
                  >
                    <b-spinner
                      v-if="contactUs.loading"
                      small
                    />
                    <span v-else>Submit</span>
                  </b-button>
                  <b-button
                    type="reset"
                    variant="secondary"
                    class="ml-1"
                    @click="resetContactUsForm"
                  >
                    Reset Form
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BCard, BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { mapGetters } from 'vuex'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BRow,
    BCol,
    BSpinner,
  },
  data() {
    return {
      contactUs: {
        name: '',
        company: '',
        email: '',
        telephone: '',
        subject: '',
        message: '',
        // Flags
        loading: false,
      },
      userContactDetails: {},
      resetPassword: {
        username: '',
        email: '',
        // Flags
        loading: false,
      },
      required,
      email,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (isLoggedIn) {
          this.loadUserData()
        } else {
          Object.keys(this.userContactDetails).forEach(field => {
            if (this.contactUs[field] === this.userContactDetails[field]) {
              this.contactUs[field] = ''
            }
          })
          this.userContactDetails = {}
        }
      },
    },
  },
  methods: {
    async loadUserData() {
      try {
        const response = await this.$http.get('account.cfc', {
          params: { method: 'getUserLogin' },
        })
        if (!this.isLoggedIn || !response.data.success || !response.data.data) return

        const user = response.data.data
        this.userContactDetails = {
          name: user.fullName || '',
          company: user.companyName || '',
          email: user.email || '',
          telephone: user.telephone || '',
        }
        Object.keys(this.userContactDetails).forEach(field => {
          if (this.userContactDetails[field]) {
            this.contactUs[field] = this.userContactDetails[field]
          }
        })
      } catch (error) {
        console.error('Error loading contact details:', error)
      }
    },
    async submit() {
      const result = await this.$refs.contactUsRules.validate()
      if (!result) return

      // Reset flags
      this.contactUs.loading = true

      this.$http
        .get('help.cfc', {
          params: {
            method: 'sendEnquiry',
            submittedForm: this.contactUs,
          },
        })
        .then(response => {
          if (response.data.success) {
            this.contactUs.loading = false
            this.resetContactUsForm()

            this.$refs.contactUsRules.reset()

            this.$bvToast.toast('Your enquiry has been sent to our team', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
          } else {
            this.contactUs.loading = false
            this.resetContactUsForm()

            this.$refs.contactUsRules.reset()

            this.$bvToast.toast('Your enquiry could not be sent. Please try again', {
              title: 'Failed',
              variant: 'danger',
              solid: true,
            })
          }
        })
    },
    resetContactUsForm() {
      this.contactUs = {
        name: '',
        company: '',
        email: '',
        telephone: '',
        ...this.userContactDetails,
        subject: '',
        message: '',
        loading: false,
      }
    },
    async submitResetPassword() {
      const result = await this.$refs.resetPasswordRules.validate()
      if (!result) return

      // Reset flags
      this.resetPassword.loading = true

      // Make the API call
      setTimeout(() => {
        this.resetPassword.loading = false
        this.resetPassword.username = ''
        this.resetPassword.email = ''

        this.$refs.resetPasswordRules.reset()

        this.$bvToast.toast('Your form has been submitted', {
          title: 'Success',
          variant: 'success',
          solid: true,
        })
      }, 3000)
    },
  },
}
</script>

<style>

</style>
